import React, { useEffect, useState, useCallback } from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import { Card, Col, Container, Dropdown, Row, Table, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import InputField from '../component/InputField'
import PrimaryGradientButton from '../component/PrimaryGradientButton'
import TierCard from '../component/TierCard'
import ProfileProgressBar from '../component/ProfileProgressBar'
import ProfilePic from '../assets/images/profilePicDefault.png'
import SelectDropDown from '../component/SelectDropDown'
import DatePicker from '../component/DatePicker'
import ProfileService from '../services/Profile'
import awardSymbol from '../assets/images/awardSymbol.png'
import awardCup from '../assets/images/cup.png'
import OtherService from '../services/Other'
import InputTypePassword from './../component/InputTypePassword';
import { Clock } from 'react-feather'

import AlertMsg from '../component/AlertMsg';
import OTPBox from '../component/OTPBox'
import Loader from '../component/Loader'
import Header from '../component/Header'
import {useSelector, useDispatch} from 'react-redux';
import { addShowPoints, addDocumentExist , addLanguage} from '../redux/slices/currentUserSlice'
import ModalComponent from '../component/ModalComponent'
import { useNavigate } from "react-router-dom";
import toast from 'react-hot-toast';
import RegistrationService from '../services/registration'
import DocumentImage from '../component/DocumentImage'
import UploadFile from '../component/UploadFile'
import NoData from '../component/NoData'
import { addTotalCartItems } from '../redux/slices/countSlice'
import { addPersonalInfo } from '../redux/slices/personalInfoSlice'
import MapComp from '../component/Modals/MapModal'
import DOMPurify from "dompurify";
import { parseSafeHtml } from "../utils/safeHtmlParser";

const Profile = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const currentBrand =  useSelector(
    state => state.userTypeSlice.currentBrand,
  );
  const profileResponse = useSelector(
    state => state.userTypeSlice.personalInfoResponse,
  );

  const [hierName, setHierName] = useState('');
  const [hireCode, setHireCode] = useState('');
  const [conId, setConId] = useState('');
  const [canDelete, setCanDelete] = useState('');
  const [hierDesc, setHierDesc] = useState('');
  const [hierId, setHierId] = useState('');
  const [userlogData, setUserlogData] = useState();
  const [allLanguages, setAllLanguages] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState({
    id: '',
    title: '',
    code: '',
  });
  const [isConnected, setIsConnected] = useState(false);
  const [token, setToken] = useState(null);
  const [GSTN, setGSTN] = useState(null);
  const [panImage, setPanImage] = useState('');
  const [frontImage, setFrontImage] = useState('');
  const [backImage, setBackImage] = useState('');
  const [kycLoading, setKycLoading] = useState(false);
  const [showKycModal, setShowKycModal] = useState(false);
  const [gstnErr, setGstnErr] = useState('');
  const [companyInfo, setCompanyInfo] = useState({});
  const [currentAddress, setcurrentAddress] = useState('');
  const [isSelected, setSelection] = useState(false);
  const [location, setLocation] = useState(null);
  const [locationmodalSt, setlocationmodalSt] = useState(false);
  const [nearbyDealers, setNearbyDealers] = useState([]);

  // Activity list show more button
  const [visibleItemCount, setVisibleItemCount] = useState(10);
  const handleShowMore = () => {
    setVisibleItemCount(prevCount => prevCount + 10);
  };
  const [userInfo, setUserInfo] = useState(JSON.parse(localStorage.getItem("userData")));
  //Alert
  const [isLoginSuccess, setIsLoginSuccess] = useState({ isLogin: true, heading: '', text: '' })
  const [showAlert, setShowAlert] = useState(false);
  const [noDataMsg,setNoDataMsg] = useState(false)
  //Tab creation//
  const [personalInfoTab, setPersonalInfoTab] = useState(true);
  const [companyInfoTab, setCompanyInfoTab] = useState(false);
  const [eKycInfoTab, seteKYCInfoTab] = useState(false);
  const [tierInfoTab, setTierInfoTab] = useState(false);
  const [disclaimerInfoTab, setDisclaimerInfoTab] = useState(false);
  const [activityListTab, setActivityListTab] = useState(false);
  const [changePasswordInfoTab, setChangePasswordTab] = useState(false);
  const [showAlertPassword, setShowAlertPassword] = useState(false);
  const [showAlertPasswordMatch, setShowAlertPasswordMatch] = useState(false);
  const [buttonHidden, setButtonHidden] = useState(false);
  const [loadingDealer, setLoadingDeaeler] = useState(true);
  const [changeLanguageTab, setChangeLanguageTab] = useState(false);
  const [nearByDealersTab, setNearByDealersTab] = useState(false);
  const [deleteMyAccountTab, setDeleteMyAccountTab] = useState(false);
  const handleTabClick = (tabName) => {
    setPersonalInfoTab(tabName === 'personal');
    setCompanyInfoTab(tabName === 'company');
    seteKYCInfoTab(tabName === 'eKYC');
    setTierInfoTab(tabName === 'tier');
    setDisclaimerInfoTab(tabName === 'disclaimer');
    setChangePasswordTab(tabName === 'changepsw');
    setActivityListTab(tabName === 'activity');
    setChangeLanguageTab(tabName === 'changeLang');
    setNearByDealersTab(tabName === 'nearDealers');
    setDeleteMyAccountTab(tabName === 'deleteMyAccount');
  };

  //OTP Match
  const [otpValue, setOtpValue] = useState(false)
  //OTP BOX
  const [pin1, setPin1] = useState("")
  const [pin2, setPin2] = useState("")
  const [pin3, setPin3] = useState("")
  const [pin4, setPin4] = useState("")
  const [pin5, setPin5] = useState("")
  const [pin6, setPin6] = useState("")
  //Change Password
  const [isResetPassword, setIsResetPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  // e-KYC
  const [myprofile, setMyProfile] = useState('');
  const [showKycDetails, setShowKYCDetails] = useState(true);
  const [loadingst, setLoadingst] = useState(false);
  const [contactId, setContactId] = useState('');
  const dispatch = useDispatch();
  const [docType, setDocType] = useState({
    id: '',
    title: '',
  });
  const [selectUserKYC, setSelectedUserKYC] = useState({
    profilePic: '',
    panNo: '',
    panImage: '',
    aadharNo: '',
    aadharImageFront: '',
    aadharImageBack: '',
    voterId: '',
    voterImageFront: '',
    voterImageBack: '',
    DLNo: '',
    DLImageFront: '',
    DLImageBack: '',
  });
  const [checkKyc, setCheckKyc] = useState(1);
  const [identity_number, setidentity_number] = useState('');
  const [docErr, setDocErr] = useState('');
  const [docTypeRegex, setDocTypeRegex] = useState(null);
  const [type, setType] = useState('');

  // Nearby dealers
  const [locloading, setLocLoading] = useState(false);
  const [loadingApi, setLoadingApi] = useState(false);
  const [selLang, setSelLang] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [currentTab, setCurrentTab] = useState('list');
  const [pendingKYC, setPendingKYC] = useState(false);

  const handleRegistrationPasswordInput = (e) => {
    setIsResetPassword(e.target.value)
  }
  const handleRegistrationConfirmPasswordInput = (e) => {
    setConfirmPassword(e.target.value)
  }

  const otpValueFromField = pin1 + pin2 + pin3 + pin4 + pin5 + pin6;

  const handleSentOTP = async () => {

    const passReg = /^(?=.*[A-Z])(?=.*\d)(?=.*[@.#$!%*?&])[A-Za-z\d@.#$!%*?&]{8,}$/;
    if (!isResetPassword) {
      toast.error("Password cannot be blank");
      return;
    }
  
    if (!passReg.test(isResetPassword)) {
      toast.error("Password must be at least 8 characters long, contain one uppercase letter, one special character, and one number.");
      return;
    }
  
    if (isResetPassword !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }
  
    try {
      const token = localStorage.getItem('access_token');
      const payload = {
        mobile_number: personaiInfo.mobile_number
      };
  
      setButtonHidden(true);
  
      const res = await ProfileService.sendOTP(payload, token);
  
      // setShowAlert(true);
      // setIsLoginSuccess({ isLogin: true, text: res.response.message });
      toast.success(res.response.message)
  
      setTimeout(() => {
        setOtpValue(true);
      }, 1000);
      
    } catch (error) {
      console.error('OTP Sending Failed');
      toast.error("Failed to send OTP. Please try again.");
    }
  };
  
  const handlePasswordUpdate = async () => {
    try {
      const token = localStorage.getItem('access_token');
      
      const payload = {
        otp: otpValueFromField,
        password: isResetPassword
      };
  
      const res = await ProfileService.changePassword(payload, token);
      if (res.success === true && res.response.message !== 'Invalid OTP') {  
      // setShowAlert(true);
      toast.success(res.response.message)
        // setIsLoginSuccess({ isLogin: true, text: res.response.message });
  
        // toast.success(res.response.message);
  
        setTimeout(() => {
          // setShowAlert(false);
          navigate("/");
        }, 2000);
  
        // window.location.reload();
        fetchData();
      } else if(res.response.message == 'Invalid OTP') {
        // setShowAlert(true);
        // setIsLoginSuccess({ isLogin: false, text: res.response.message });
        toast.error(res.response.message);
      }
    } catch (error) {
      toast.error('Password Change Fail');
    }
  };
  useEffect(() => {
    if (otpValueFromField?.length === 6) {
      // setShowAlert(false);
      handlePasswordUpdate();
    }
  }, [otpValueFromField]);
  

  //Gender Selection
  const Gender = [
    {
      id: 'M',
      title: 'M'
    },
    {
      id: 'F',
      title: 'F'

    }
  ]

  const [documentType, setDocumentType] = useState([
    {
      title: 'Aadhar',
      id: 'aadharcard',
    },
    {
      title: 'Voter ID',
      id: 'voterId',
    },
    {
      title: 'Driving License',
      id: 'driving_license',
    },
    {
      title: 'PAN',
      id: 'pan',
    },
  ]);

  const [selectedGender, setSelectedGender] = useState({ id: "", title: "" });
  const [selectedKYC, setSelectedKYC] = useState({ id: '', title: '' });
  const handleGenderChange = (selectedValue) => {
    // setPersonalInfo((p)=>({
    //   ...p,gender:selectedValue
    // }))
    setSelectedGender(selectedValue)
  }
  const handleKYCChange = (selectedValue) => {

  }
  //Personal Info State
  const [personaiInfo, setPersonalInfo] = useState({ full_name: '', profile_pic: '', identity_number: '', identity_number_type: '', mobile_number: '', gender: '', date_of_birth: '', email_address: '' })
  const [full_name, setfull_name] = useState('');
  const [temporaryName, setTemporaryName] = useState(''); 
  const [confirmedName, setConfirmedName] = useState('');
  const [profileError, setprofileError] = useState({
    identity_number_type: '',
    GSTN: '',
    email_address: '',
    mobile_number: '',
  });

  //Personal Name update
  const handleUserNameInfoUpdate = (e) => {
    setPersonalInfo({
      ...personaiInfo,
      full_name: e.target.value
    });
  };
  //Personal Email update
  const handleUserEmailInfoUpdate = (e) => {
    setPersonalInfo({
      ...personaiInfo,
      email_address: e.target.value
    });
  };
  //Personal Gender update
  // const handleUserGenderInfoUpdate = (e) => {
  //   setPersonalInfo({
  //     ...personaiInfo,
  //     gender: selectedGender
  //   });
  // };
  //Personal DOB update
  const handleUserDOBInfoUpdate = (e) => {
    setPersonalInfo({
      ...personaiInfo,
      date_of_birth: e.target.value
    });
  };
  //Disclaimer
  const [apiData, setApiData] = useState('');
  //Activity
  const [activityData, setActivityData] = useState('');
  //Tier Information
  const [isPointInfo, setIsPointInfo] = useState('')
  //Company Information
  const [isCompanyName, setIsCompanyName] = useState('')
  //Local Storage Value

  const fetchData = async () => {
    try {
      const userInfo = JSON.parse(localStorage.getItem('userData'));
      const contactId = userInfo.dcm_contacts_id;
      setContactId(contactId)
      setConId(contactId)
      const token = localStorage.getItem('access_token');

      // Personal Info Show API
      const personalInfoResponse = await ProfileService.getPersonalInfo(token);
      setPersonalInfo(personalInfoResponse.response.Data);
      setSelectedGender({ id: personalInfoResponse.response.Data.gender, title: personalInfoResponse.response.Data.gender });
      dispatch(addPersonalInfo({ personalInfo: personalInfoResponse.response.Data }));
      setLoading(false)
      // Company name
      const companyDetailsResponse = await ProfileService.getCompanyDetails(token);

      const { message, data } = companyDetailsResponse.response.data;
      setIsCompanyName(data.length === 0 ? message : data)
      setLoading(false)

      // Disclaimer
      const disclaimerResponse = await OtherService.contentSpot("Disclaimer", token);
     
      if(disclaimerResponse.error == false) 
      {
        if(disclaimerResponse.data.content_banner_details_contact.content_spot_contents.length > 0)
        {
          setApiData(disclaimerResponse.data.content_banner_details_contact.content_spot_contents);
          setLoading(false)
          setNoDataMsg(false)
        }
        else{
          setLoading(false)
          setNoDataMsg(true)
        }
      }
      

      // Activity
      const activityResponse = await OtherService.activityList(token);
      
      if(activityResponse.response_code == 200)
      {
        if(activityResponse.data.length > 0)
        {
          setActivityData(activityResponse.data);
          setLoading(false)
          setNoDataMsg(false)
        }
      }
      else{
        setLoading(false)
        setNoDataMsg(true)
      }

    } catch (error) {
      console.error('Error:');
    }
  };

  useEffect(() => {

    fetchData();


  }, []);

  //Tier Card / My Profile - derived from profile data already fetched in TopBar
  useEffect(() => {
    setLoadingst(false);
    if (!profileResponse?.response?.message) return;
    const { message } = profileResponse.response;
    setIsPointInfo(message);
    if (profileResponse.success === true) {
      localStorage.setItem('isApproved', message.is_approved);
      setMyProfile(message);
      dispatch(addShowPoints({ showPoints: message.showPoints == 'true' }));
      localStorage.setItem('documentExist', message.document_exist);
      dispatch(
        addDocumentExist({
          documentExist: message.document_exist == 'true' ? true : false,
        }),
      );
    } else {
      setMyProfile('');
    }
  }, [profileResponse]);

// useEffect(() => {
//   const getMyprofile = async contactId => {
//     setLoadingst(true);
//     ProfileService.getProfile(contactId)
//       .then(res => {
//         setLoadingst(false);

//         if (res.success === true) {

//           localStorage.setItem(
//             'isApproved',
//             res.response.message.is_approved,
//           );
//           setMyProfile(res.response.message);
//           dispatch(
//             addShowPoints({
//               showPoints: res.response.message.showPoints == 'true',
//             }),
//           );
//           localStorage.setItem(
//             'documentExist',
//             res.response.message.document_exist,
//           );
//           dispatch(
//             addDocumentExist({
//               documentExist:
//                 res.response.message.document_exist == 'true' ? true : false,
//             }),
//           );
//         } else {
//           setMyProfile('');
//         }
//       })
//       .catch(err => {
//         setLoadingst(false);
//         console.error("Error");
//       });
//   };
//   if(contactId) 
//     getMyprofile(contactId)
// }, [contactId])
  // 
 

  // 
  useEffect(() => {
    const getKYCDetails = async () => {
      try {
        const payload = {
          userType: myprofile?.hierarchyName,
          phone: myprofile?.phone_number,
          brand_id: parseInt(myprofile?.brandId),
        };
        const token = localStorage.getItem("access_token");

        const res = await ProfileService.getKYCDetails(payload);

        const kycDetails = res?.response?.kycDetails || {};
        setSelectedUserKYC(kycDetails);

        if (kycDetails.panIsApproved === "1") {
          setDocumentType([
            { title: "Aadhar", id: "aadharcard" },
            { title: "Voter ID", id: "voterId" },
            { title: "Driving License", id: "driving_license" },
            { title: "PAN", id: "pan" },
          ]);
          setPendingKYC(false);
        } else {
          setPendingKYC(true);
        }

        if (Object.keys(kycDetails).length === 0) {
          setShowKYCDetails(false);
        }
      } catch (err) {
        console.error("kyc err=>");
      }
    };
    if(myprofile) {
      getKYCDetails();
    }
  }, [myprofile]);

  //Update User Profile
  const handleUpdateUserProfile = async () => {
    try {
  
      const userInfo = JSON.parse(localStorage.getItem("userData"));
      const contactId = userInfo?.dcm_contacts_id;
      const conId = contactId;
      const token = localStorage.getItem("access_token");
  
      const fullName = temporaryName?.trim();
      const email = personaiInfo.email_address?.trim();
      const dob = personaiInfo.date_of_birth?.trim(); 
  
      if (!fullName) {
        toast.error("Full name is required.");
        return;
      }
  
      const nameRegex = /^[A-Za-z\s]+$/; 
      if (!nameRegex.test(fullName)) {
        toast.error("Full name should contain only alphabets.");
        return;
      }
  
      if (!email) {
        toast.error("Email address is required.");
        return;
      }
  
      const emailRegex = /^[A-Za-z0-9._]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
      if (!emailRegex.test(email)) {
        toast.error("Invalid email format. Only letters, numbers, dots, and '@' are allowed.");
        return;
      }
  
      if (!dob) {
        toast.error("Date of birth is required.");
        return;
      }
  
      const today = new Date();
      const minDOB = new Date();
      minDOB.setFullYear(today.getFullYear() - 18);
  
      const userDOB = new Date(dob);
  
      if (userDOB > minDOB) {
        toast.error("You must be at least 18 years old.");
        return;
      }

  
  
      const payload = {
        full_name: fullName,
        mobile_number: personaiInfo.mobile_number,
        date_of_birth: dob,
        email_address: email,
        gender: selectedGender.id,
        marital_status: "Married",
      };
  
  
      const response = await ProfileService.updatePersonalInformation(payload);
  
  
      if (response.success === true) {
        toast.success(response.response.message);
        fetchData();
      } else {
        setShowAlert(true);
        setIsLoginSuccess({ isLogin: false, text: response.response.message });
        toast.error(response.response.message);
      }
    } catch (error) {
      console.error("Error updating profile:");
      toast.error("An error occurred while updating the profile.");
    }
  };

  function handleLocationClick() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(success, er);
    } else {
    }
  }

  function success(position) {
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;
  }

  function er() {
  }

  let resendTimerInterval;
  useEffect(() => {
    setCheckKyc(1);
    setidentity_number('');
    setDocErr('');
    if (docType.title) {
      if (docType.title === 'Aadhar') {
        setDocTypeRegex(/^(\d{12})$/);
      } else if (docType.title === 'Voter ID')
        setDocTypeRegex(/^[A-Z]{3}[0-9]{7}$/);
      else if (docType.title === 'Driving License') {
        setDocTypeRegex(
          /^(([A-Z]{2}[0-9]{2})( )|([A-Z]{2}-[0-9]{2}))((19|20)[0-9][0-9])[0-9]{7}$/,
        );
      } else if (docType.title === 'PAN') {
        setDocTypeRegex(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/);
      }
    }
    setType(docType.title);
  }, [docType]);

  const [isEditing, setIsEditing] = useState(false);
  const [kycType, setKycType] = useState("");
  const [documentNumber, setDocumentNumber] = useState("");
  const [gstNumber, setGstNumber] = useState("");
  
    const handleEditClick = () => {
      setIsEditing(true);
    };
  
    const handleSubmit = () => {
      setIsEditing(false);
    };

    const handleAadharFrontUpload = (e) => {
      const file = e.target.files[0];
      if (file) {
      }
    };
    
    const handleAadharBackUpload = (e) => {
      const file = e.target.files[0];
      if (file) {
      }
    };

    const handleDrivingLicenseFrontUpload = (e) => {
      const file = e.target.files[0];
      if (file) {
      }
    };
    
    const handleDrivingLicenseBackUpload = (e) => {
      const file = e.target.files[0];
      if (file) {
      }
    };

    const handleVoterIdFrontUpload = (e) => {
      const file = e.target.files[0];
      if (file) {
      }
    };
    
    const handleVoterIdBackUpload = (e) => {
      const file = e.target.files[0];
      if (file) {
      }
    };

    const handlePanImageUpload = (e) => {
      const file = e.target.files[0];
      if(file) {
          
      }
    }

    const handleShowModal = (event) => {
      setSelectedEvent(event);
      setIsModalOpen(true);
  };
    
    const handleDeleteMyAccount = () => {
      handleShowModal()

  }

  const handleLocationAccess = () => {
    if (navigator.geolocation) {
      
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
            
          try {
            const res = await OtherService.nearbyDealerList(latitude, longitude);
            setLoadingDeaeler(false)
            if (Array.isArray(res?.response?.data)) {
              setNearbyDealers(res.response.data);
            } else {
              console.warn("Unexpected API Response Structure:", res);
              setNearbyDealers([]); 
            }
          } catch (error) {
            setLoadingDeaeler(false)
            console.error("Error fetching nearby dealers:");
            alert("Failed to fetch nearby dealers.");
          }
        },
        (error) => {
          console.error("Error accessing location:");
          alert("Location access denied or unavailable.");
        }
      );
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  };
  
  
  
  const getCompanyInfo = async (tok) => {
    try {
      const res = await ProfileService.getCompanyDetails(tok);
      
      setLoadingst(false);
  
      if (res.success) {
        const response = res.response.data.data;
  
        if (response.length > 0) {
          setCompanyInfo(response[0].companyName);
        } else {
          setCompanyInfo(res.response.data.message);
        }
      } else {
        setCompanyInfo(null);
      }
    } catch (error) {
      setLoadingst(false);
      console.error("Error fetching company info:");
    }
  };
  
  const handleLocmodalClose = () => {
    setlocationmodalSt(false);
    setLocation(null);
    setSelection(false);
    setcurrentAddress('');
  };

  
    const renderViewMode = () => (
      <div className="userInfoBox">
        <div className="dashboard-title">
          <h4 className='gradient-text'>e-KYC Information</h4>
        </div>
        <div className="dashboard-details">
          <Row>
            <Col xs={12} lg={7}>
              <Row>
                 {selectUserKYC.panNo && <Row className='userInfoBox'>
              <Col xs={12} lg={12} className="mb-2">
                  <InputField inputFieldLabel={"PAN"} value={selectUserKYC.panNo} editable={false} />
              </Col>
              <Col xs={12} lg={6}>
                <DocumentImage imageUrl={selectUserKYC.panImage} title='PAN'  />
                {pendingKYC && <div style={{ margin: '10px 0', color: '#007bff', fontSize: '14px' }}>Pan Approval Pending</div>}
              </Col>
            
            </Row>}
           {selectUserKYC.aadharNo && <Row className='userInfoBox'>
              <Col xs={12} lg={12} className="mb-2">
                  <InputField inputFieldLabel={"Aadhar"} value={selectUserKYC.aadharNo} editable={false} />
              </Col>
              <Col xs={12} lg={6}>
                <DocumentImage imageUrl={selectUserKYC.aadharImageFront} title='Aadhar Front'  />
              </Col>
              <Col xs={12} lg={6}>
                <DocumentImage imageUrl={selectUserKYC.aadharImageBack} title='Aadhar Back'  />
              </Col>
            
            </Row>}
           {selectUserKYC.voterId && <Row  className='userInfoBox mt-5'>
              <Col xs={12} lg={12} className="mb-2">
                  <InputField inputFieldLabel={"Voter ID"} value={selectUserKYC.voterId} editable={false} />
              </Col>
              <Col xs={12} lg={6}>
              <DocumentImage imageUrl={selectUserKYC.voterImageFront} title='Voter ID Front'  />
              </Col>
              <Col xs={12} lg={6}>
              <DocumentImage imageUrl={selectUserKYC.voterImageBack} title='Voter ID Back'  />
              </Col>
            
            </Row>}
           {selectUserKYC.DLNo && <Row className='userInfoBox mt-5'>
              <Col xs={12} lg={12} className="mb-2">
                  <InputField inputFieldLabel={"Driving Licence No."} value={selectUserKYC.DLNo} editable={false} />
              </Col>
              <Col xs={12} lg={6}>
              <DocumentImage imageUrl={selectUserKYC.DLImageFront} title='Driving License Front'  />
              </Col>
              <Col xs={12} lg={6}>
              <DocumentImage imageUrl={selectUserKYC.DLImageBack} title='Driving License Back'  />
              </Col>
            
            </Row>}
  
                <Col xs={12} className="mt-4">
                  <PrimaryGradientButton buttonText="Edit" onClick={handleEditClick} />
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </div>
    );

    const renderEditMode = () => (
      <div className="userInfoBox">
        <div className="dashboard-title">
          <h4>e-KYC Information</h4>
        </div>
        <div className="dashboard-details">
          <Row>
            <Col xs={12} lg={7}>
              <Row>

              <Col xs={12} className="mt-2">
              <PrimaryGradientButton buttonText="View" onClick={handleSubmit} />
              </Col>

                <Col xs={12}>
                  <div className="mobileFieldBox mt-4">
                    <SelectDropDown requiredStar={"*"} labelName={"Please select KYC Type"} options={documentType} selectedValue={selectedKYC} setSelectedValue={setSelectedKYC} />
                  </div>
                </Col>

                <Col xs={12}>
                  <div className="mobileFieldBox">
                    <InputField inputFieldLabel={"Document No"} value={documentNumber} setValue={setDocumentNumber} requiredStar={"*"} />
                  </div>
                </Col>

                <Col xs={12}>
                  <div className="mobileFieldBox">
                    <InputField inputFieldLabel={"GST No"} value={gstNumber} setValue={setGstNumber} />
                  </div>
                </Col>

                {(selectedKYC.id === "aadharcard" || selectedKYC.id === "voterId" || selectedKYC.id === "driving_license") && (
                  <Col xs={12} lg={12} className='mt-2'>
                    <UploadFile label={`Upload ${selectedKYC.title} Front Image`}
                        requiredStar="*"
                        accept="image/*"
                        value={frontImage}
                        setValue={setFrontImage} />
                    <UploadFile label={`Upload ${selectedKYC.title} Back Image`}
                      requiredStar="*"
                      accept="image/*"
                      value={backImage}
                      setValue={setBackImage} />
                    </Col>
                  )}

                  {
                    selectedKYC.id === "pan" && (
                      <Col xs={12} lg={12} className='mt-2'>
                      <UploadFile label={`Upload ${selectedKYC.title} Image`}
                        requiredStar="*"
                        accept="image/*"
                        value={panImage}
                        setValue={setPanImage} />
                      </Col>
                    )
                  }

                <Col xs={12} className="mt-4">
                  <PrimaryGradientButton buttonText="Submit" onClick={ekycHandler} />
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </div>
    );

    useEffect(() => {
      setCheckKyc(1);
      setidentity_number('');
      setDocErr('');
      if (docType.title) {
        if (docType.title === 'Aadhar') {
          setDocTypeRegex(/^(\d{12})$/);
        } else if (docType.title === 'Voter ID')
          setDocTypeRegex(/^[A-Z]{3}[0-9]{7}$/);
        else if (docType.title === 'Driving License') {
          setDocTypeRegex(
            /^(([A-Z]{2}[0-9]{2})( )|([A-Z]{2}-[0-9]{2}))((19|20)[0-9][0-9])[0-9]{7}$/,
          );
        } else if (docType.title === 'PAN') {
          setDocTypeRegex(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/);
        }
      }
      setType(docType.title);
    }, [docType]);

    // will check later
    // useEffect(() => {
    //   const fetchData = async () => {

    //     try {
    //       setHireCode(JSON.parse(localStorage.getItem("userData")).hierCode);
    //       setConId((localStorage.getItem("userData")).username);
    //       const del = JSON.parse(localStorage.getItem("userInfo")).canDelete;
    //       setCanDelete(del+'')
    //       // setSelLang(localStorage.getItem("lang") || "");
    //       // setHierDesc(localStorage.getItem("hierDesc") || "");
    //       // setHierName(localStorage.getItem("hierDesc") || "");
    //       // setHierId(localStorage.getItem("hierId") || "");
  
    //       const storedContactId = localStorage.getItem("contactId");
    //       if (storedContactId) {
    //         setContactId(storedContactId);

    //       }
  
    //       const storedUserlogData = localStorage.getItem("userlogData");
    //       if (storedUserlogData) {
    //         const parsedData = JSON.parse(storedUserlogData);
    //         setUserlogData(parsedData);

    //       }
  
    //       const res = await RegistrationService.getLanguages();

  
    //       if (res.success) {
    //         const langs = res.response.languageDetails.map((lang) => ({
    //           id: lang.id,
    //           title: lang.name,
    //           code: lang.language_code,
    //         }));

    //         setAllLanguages(langs);
    //         if (langs.length > 0) {
    //           setSelectedLanguage(langs[0]);
    //         }
    //       }
    //     } catch (err) {
    //       console.error("Error fetching data:");
    //     }
    //   };
  
    //   fetchData();
    // }, [isConnected]);

    useEffect(() => {
      const checkBasicProfile = async () => {
        try {
          const isBasicProfileDone = localStorage.getItem("isBasicProfileDone");
  
          if (isBasicProfileDone === "false" && hireCode === "contractor") {
            navigate("/"); 
          }
        } catch (err) {
          console.error("Error checking basic profile:");
        }
      };
  
      checkBasicProfile();
    }, [hireCode, navigate]);

    // const data = useCallback(async () => {
    //   try {
    //     const token = localStorage.getItem("access_token");
  
    //     if (token) {
    //       setToken(token);
    //       // getPersonalInfo(token);
    //       // getCompanyInfo(token);
    //       // getDisclaimerInfo(token);
  
    //       if (contactId) {
    //         getMyprofile(contactId);
    //       }
  

    //     }
    //   } catch (err) {
    //     console.error("Error fetching data:");
    //   }
    // }, [contactId]);

    function validateDoc(docType, docNum) {
      let idRegex = new RegExp();
      if (docType.title == 'Aadhar') {
        idRegex = new RegExp(/^(\d{12})$/);
      } else if (docType.title == 'Voter ID') {
        idRegex = new RegExp(/^[A-Z]{3}[0-9]{7}$/);
      } else if (docType.title == 'Driving License') {
        idRegex = new RegExp(
          /^(([A-Z]{2}[0-9]{2})( )|([A-Z]{2}-[0-9]{2}))((19|20)[0-9][0-9])[0-9]{7}$/,
        );
      } else if (docType.title == 'PAN') {
        idRegex = new RegExp(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/);
      }
      return idRegex.test(docNum);
    }

    const ekycHandler = async () => {
      const gstnRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

      
      const regex = new RegExp(gstnRegex);
      if(!selectedKYC.id) {
        return toast.error("Select document type");
      }
      if(gstNumber && !regex.test(gstNumber)) {
        return toast.error("Kindly enter valid GSTN no.");
      }
      if(!validateDoc(selectedKYC, documentNumber)) {
        return toast.error(`Enter valid ${selectedKYC.title} details`);
      }
      if(selectedKYC.id == "pan" && !panImage) {
        return toast.error(`${selectedKYC.title} image required`);
      }
      if((selectedKYC.id == "aadharcard" || selectedKYC.id == "voterId" || selectedKYC.id == "driving_license") && !(frontImage && backImage)) {
          return toast.error(`${selectedKYC.title} front and back images required`);
      }

      // if (
      //   identity_number &&
      //   validateDoc(docType, identity_number) &&
      //   (GSTN ? gstnRegex.test(GSTN) : true)
      // ) {
      //   setLoading(true);

    
      //   if (!docType.id) {
      //     window.alert("Please select a KYC type.");
      //     setLoading(false);
      //     return;
      //   }
    
      //   if (!identity_number) {
      //     window.alert(`Please enter your ${docType.title} number.`);
      //     setLoading(false);
      //     return;
      //   }
    

    
        try {
          setLoadingApi(true);
          const payload = {
            identity_number_type: selectedKYC.id,
            identity_number:documentNumber,
            GSTN: GSTN || null,
          };
          
          const res = await ProfileService.updateEkycInformation(payload);
    
    
          if (res.success) {
            const formData = new FormData();
    
            if (panImage) {
              formData.append("pan_image", panImage.file);
            }
    
            if (frontImage) {
              formData.append("front_image", frontImage.file);
            }
    
            if (backImage) {
              formData.append("back_image", backImage.file);
            }
    
            formData.append("KYCType", selectedKYC.id);
            formData.append("KYCDetails", documentNumber);
            formData.append("contact_id", contactId);
    
            try {
              const uploadRes = await ProfileService.uploadEkycDoc(formData);
    
              setLoadingApi(false);
              setKycLoading(false);
              setShowKycModal(false);
              setCheckKyc(1);
              setidentity_number("");
              setShowKYCDetails(true);
              setGstNumber("");
              setDocType({ id: "", title: "" });
              setFrontImage(null);
              setBackImage(null);
              setPanImage(null);

              setSelectedKYC({});
              setDocumentNumber("");
    
    
              if (uploadRes.success) {
                // localStorage.setItem("documentExist", "true");
                // dispatch(addDocumentExist({ documentExist: true }));
                setIsEditing(false);
                toast.success(uploadRes.response.message);
                fetchData();

              } else {
                toast.error(uploadRes.response.message);
              }
            } catch (uploadErr) {
              console.error("Upload error:");
              setLoadingApi(false);
            }
          } else {
            toast.error(res.message);
          }
        } catch (err) {
          console.error("Error updating eKYC:");
          setLoadingApi(false);
          setKycLoading(false);
          setShowKycModal(false);
          setCheckKyc(1);
        }
      
    };
    

    function onlyAlphabetHandler(text) {
      const alphaRegex = new RegExp(/^[a-zA-Z ]*$/);
      if (alphaRegex.test(text)) {
        setfull_name(text);
      }
    }

    const resetTemporaryName = () => {
      setTemporaryName(personaiInfo.full_name);
      setConfirmedName(personaiInfo.full_name);
    };

    useEffect(() => {
      resetTemporaryName();
    }, [personaiInfo.full_name]);
    
  // }

  function deleteMyAccountHandler() {
    RegistrationService.deleteProfile()
        .then(res => {
          if (res.success) {
            toast.success(res.response.message)
            localStorage.clear();
            // window.location.reload();
            dispatch(addTotalCartItems({
                cartCount:0
            }))
            navigate('/');
          } else {
            toast.error(res.response.message)
          }
        })
        .catch(err => {
          toast.error("Something went wrong");
        });
  }

      const [personaiInformation, setPersonalInformation] = useState({ full_name: ''})
      const personalInfoFromStore = useSelector((state) => state.personalInfo.personalInfo);
    useEffect(() => {
        if (personalInfoFromStore) {
          setPersonalInformation(personalInfoFromStore);
        }
    },[currentBrand, personalInfoFromStore])

  return (
    <>
      {loading && <Loader />}
      <BreadCrumbSecttion
        pageTitle="My Profile"
        currentPageName="My Profile" />
      {/* Layout */}
      <section className='padTop50'>
        <Container>
          <Row>
            <Col xs={12} lg={3}>
              <div className="dashboard-sidebar">
                <div className="profile-top">
                  <div className="profile-detail">
                    <div className='profileCardImg'>
                      <div className='profileCardImgWrap myPprofile'>
                        <ProfileProgressBar percentage={isPointInfo?.profileCompletion} />
                        <div className='profileImg2'>
                          {personaiInfo.profile_pic === null ? (<img src={ProfilePic} alt='image' className='img-fluid' />)
                            : (<img src={personaiInfo.profile_pic} alt='image' className='img-fluid' />)}

                        </div>
                        <p className='profie-completeTxt'>{isPointInfo?.profileCompletion}%</p>
                      </div>
                    </div>
                    <h5>{personaiInfo.full_name}</h5>
                    <h6>{userInfo.description }<span className='d-block'>Member Id:{isPointInfo.member_id}</span></h6>

                  </div>
                </div>
                <div className="myProfileTab">
                  <ul>
                    <li className={personalInfoTab ? 'activeTab' : ''}>
                      <Link onClick={() => handleTabClick('personal')} >Personal Information</Link>
                    </li>
                    {(personaiInformation?.dcm_hierarchies_id !== 18) ? <li className={eKycInfoTab ? 'activeTab' : ''}>
	                    <Link onClick={() => handleTabClick('eKYC')} >e-KYC Information</Link>
                    </li> : null}
                    <li className={changePasswordInfoTab ? 'activeTab' : ''}>
                      <Link onClick={() => handleTabClick('changepsw')} >Change Password</Link>
                    </li>
                    {/* <li className={changeLanguageTab ? 'activeTab' : ''}>
                      <Link onClick={() => handleTabClick('changeLang')} >Change Lanuguage</Link>
                    </li> */}
                    {/* <li className={companyInfoTab ? 'activeTab' : ''}>
                      <Link onClick={() => handleTabClick('company')} >Company Information</Link>
                    </li>
                    <li className={tierInfoTab ? 'activeTab' : ''}>
                      <Link onClick={() => handleTabClick('tier')} >Tier Information</Link>
                    </li>
                    <li className={changePasswordInfoTab ? 'activeTab' : ''}>
                      <Link onClick={() => handleTabClick('changepsw')} >Change Password</Link>
                    </li>
                    <li className={activityListTab ? 'activeTab' : ''}>
                      <Link onClick={() => handleTabClick('activity')} >My Activity</Link>
                    </li> */}
                    <li className={disclaimerInfoTab ? 'activeTab' : ''}>
                      <Link onClick={() => handleTabClick('disclaimer')} >Disclaimer</Link>
                    </li>
                    {(personaiInformation?.dcm_hierarchies_id !== 18) ? <li className={nearByDealersTab ? 'activeTab' : ''}>
                      <Link onClick={() => {
                        handleTabClick('nearDealers');
                        handleLocationAccess()
                      }}>Near by Dealer / Retailer / ARS</Link>
                    </li> : null}
                    {/* {(personaiInformation?.dcm_hierarchies_id !== 18) ?<li className={deleteMyAccountTab ? 'activeTab' : ''}>
                      <Link onClick={handleDeleteMyAccount} >Delete my Account</Link>
                    </li> : null} */}
                  </ul>
                </div>
              </div>
            </Col>
            <Col xs={12} lg={9}>
              {/* Personal Information */}
              {personalInfoTab &&
                <div className='userInfoBox'>
                  <div className="dashboard-title">
                    <h4 className='gradient-text'>Personal Information</h4>
                  </div>
                  <div className='dashboard-details'>
                    <Row>
                      <Col xs={12} lg={7}>
                        <Row>
                          <Col xs={12}>
                            <div className='ad-frm-pad'>
                          
                              <InputField
                                disabled={false}
                                inputFieldLabel="Name"
                                requiredStar="*"
                                value={temporaryName}
                                name="name"
                                onChange={(e) => setTemporaryName(e.target.value)} 
                              />
                            </div>

                            {/* <Col xs={12} lg={3}>
                                            <InputField
                                                requiredStar="*"
                                                inputFieldLabel="Customer Name"
                                                name="customerName"
                                                value={serviceRegistrationData.customerName}
                                                onChange={handleServiceRegistrationInput}
                                            />
                                            {customerNameValidationError &&
                                                <div className="error-message">
                                                    {customerNameValidationError}
                                                </div>
                                            }
                                        </Col> */}

                          </Col>
                          <Col xs={12}>
                            <div className='ad-frm-pad'>
                              {/* <InputField
                              inputFieldLabel="Mobile No"
                              requiredStar="*" value={personaiInfo.mobile_number}
                              name="mobile" readonly /> */}
                              <div className='mobileFieldBox '>
                                <label>Mobile No <span className='redStar'>*</span></label>
                                <div className='mobileField mt-2'>{personaiInfo.mobile_number}</div>
                              </div>
                            </div>

                          </Col>
                          <Col xs={12}>
                            <div className='ad-frm-pad'>
                              <InputField
                                disabled={false}
                                inputFieldLabel="Email"
                                value={personaiInfo.email_address}
                                name="email"
                                onChange={handleUserEmailInfoUpdate}
                              />
                            </div>
                          </Col>

                          <Col xs={12}>
                                <DatePicker 
                                inputFieldLabel="Date of Birth"
                                requiredStar="*"
                                value={personaiInfo.date_of_birth}
                                name="dob"
                                onChange={(date) => {
                                    handleUserDOBInfoUpdate({
                                        target: {
                                            name: "dob",
                                            value: date,
                                        },
                                    });
                                }}
                                />
                          </Col>

                          <Col xs={12}>
                            <div className='ad-frm-pad'>
                              <SelectDropDown labelName="Gender"
                                 disabled={false}
                                requiredStar="*"
                                options={Gender}
                                onChange={handleGenderChange}
                                selectedValue={selectedGender}
                                setSelectedValue={setSelectedGender}
                                name="gender" />
                            </div>
                          </Col>
                          
                            <Col>
                              <div className='ad-frm-pad'>
                                <div className='mobileFieldBox '>
                                  <label>Referral Code</label>
                                  <div className='mobileField m-0'>{personaiInfo.referral_code}</div>
                                </div>
                              </div>
                            </Col>
                          
                          <Col xs={12} className='mt-3'>

                            <PrimaryGradientButton buttonText="Submit" onClick={handleUpdateUserProfile} loading={loadingApi} />

                          </Col>
                         
                        </Row>
                      </Col>
                    </Row>

                  </div>

                </div>

              }
              {/* e-KYC Information */}
              {eKycInfoTab && (
                    <div>
                    {isEditing ? renderEditMode() : renderViewMode()}
                  </div>
              )}
              
              {/* Company Information */}
              {companyInfoTab &&
                <div className='userInfoBox'>
                  <div className="dashboard-title">
                    <h4>Company Information</h4>
                  </div>
                  <div className='dashboard-details'>
                    <Row>
                      <Col xs={12}>
                        <p>
                          {isCompanyName}
                        </p>
                      </Col>
                    </Row>
                  </div>
                </div>
              }
              {/* Tier Information */}
              {tierInfoTab &&
                <div className='userInfoBox'>
                  <div className="dashboard-title">
                    <h4>Tier Information</h4>
                  </div>
                  <div className='dashboard-details'>
                    <Row>
                      <Col xs={12} lg={7}>
                        <div className='tierCardBox'>
                          <TierCard
                            tierStar={awardSymbol}
                            awardCup={awardCup}
                            totalPoints={isPointInfo.totalPoints}
                            redemPoints={isPointInfo.getRedemPoints}
                            availablePoints={isPointInfo.availablePoints}
                            // nextTarget={isPointInfo.availablePoints}
                            tierName='Bronze' />
                        </div>

                      </Col>

                    </Row>
                  </div>
                </div>
              }
              {/* Change Password */}
              {changePasswordInfoTab &&
                <div className='userInfoBox'>
                  <div className="dashboard-title">
                    <h4 className='gradient-text'>Change Password</h4>
                  </div>
                  <div className='dashboard-details ad-frm-pad'>
                    <Row>
                      <Col xs={12} lg={7}>
                        <Row>
                          <Col xs={12}>
                            <InputTypePassword
                              inputFieldLabel="Password"
                              requiredStar="*"
                              autocomplete="off"
                              value={isResetPassword}
                              onChange={handleRegistrationPasswordInput} name="password" />
                          </Col>
                          <Col xs={12}>
                            <InputTypePassword
                              inputFieldLabel="Confirm Password"
                              requiredStar="*"
                              autocomplete="off"
                              value={confirmPassword}
                              onChange={handleRegistrationConfirmPasswordInput} name="confirmPassword" />
                          </Col>
                          <Col xs={12} className='mt-2'>
                            {!otpValue && !buttonHidden && (
                              <PrimaryGradientButton
                                buttonText="Send OTP"
                                onClick={handleSentOTP}
                                className='mb-3' />
                            )}
                          </Col>
                          {/* {showAlert &&
                            <div className='alertBoxWrap alertBoxWrap-full'>

                              <AlertMsg alertBoxColor={isLoginSuccess.isLogin ? 'successAlert' : 'FailedAlert'}
                                heading={isLoginSuccess.heading}
                                text={isLoginSuccess.text} >
                              </AlertMsg>

                            </div>
                          } */}
                          {otpValue &&
                            <Col xs={12}>
                              <div className='otpBox'>

                                <OTPBox
                                  pin1={pin1}
                                  pin2={pin2}
                                  pin3={pin3}
                                  pin4={pin4}
                                  pin5={pin5}
                                  pin6={pin6}
                                  setPin1={setPin1}
                                  setPin2={setPin2}
                                  setPin3={setPin3}
                                  setPin4={setPin4}
                                  setPin5={setPin5}
                                  setPin6={setPin6}

                                />
                              </div>
                              <Col xs={12}>
                                <PrimaryGradientButton className="mb-3" buttonText="Submit" requiredStar="*" onClick={handlePasswordUpdate} />
                              </Col>
                              <Col xs={12}>
                                {showAlertPasswordMatch &&
                                  <AlertMsg alertBoxColor={isLoginSuccess.isLogin ? 'successAlert' : 'FailedAlert'}
                                    heading={isLoginSuccess.heading}
                                    text={isLoginSuccess.text} />

                                }
                              </Col>
                            </Col>
                          }

                        </Row>

                      </Col>
                    </Row>
                  </div>
                </div>
              }

              {/* Language Information */}
              {changeLanguageTab &&
                <div className='userInfoBox'>
                  <div className="dashboard-title">
                    <h4>Change Language</h4>
                    </div>
                    <div className='dashboard-details'>
                      <Row>
                        <Col xs={12}>
                            <SelectDropDown 
                              labelName="Select display language"
                              requiredStar="*"
                              options={documentType}
                              selectedValue={documentType}
                              setSelectedValue={setDocumentType}
                              onChange={handleKYCChange}
                              page='searchFilter' />
                          </Col>
                      </Row>
                  </div>
                </div>}

              {/* Disclaimer Information */}
              {disclaimerInfoTab &&
                <div className='userInfoBox'>
                  <div className="dashboard-title">
                    <h4 className='gradient-text'>Disclaimer</h4>
                  </div>
                  <div className='dashboard-details'>
                    <Row>
                      {noDataMsg && <Col><div className="error-message">No Data Found</div></Col> }
                      <Col>
                        {
                          apiData.map((item) => {
                            const { content_map_id, article_detail } = item;
                            return (
                              <div key={content_map_id}>
                                {/* <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(article_detail) }}></div> */}
                                <div>{parseSafeHtml(article_detail)}</div>
                              </div>
                            )

                          })
                        }

                      </Col>

                    </Row>
                  </div>
                </div>
              }

              {/* Near by dealsers */}
              {/* {nearByDealersTab && 
                <div className="userInfoBox">
                  <div className="dashboard-title">
                    <h4>Near By Dealers</h4>
                  </div>
                  <div className="dashboard-details">
                    <Row>
                    <Col xs={4} className='mt-3'>
                      <PrimaryGradientButton buttonText="Search Nearby Dealers" onClick={handleLocationAccess}
                       />
                    </Col>
                    </Row>
                  </div>
                </div>
              } */}

{nearByDealersTab && (
        <Card className="userInfoBox">
          <div className="dashboard-title">
            <h4 className="gradient-text">Near By Dealers</h4>
          </div>
          <div className="dashboard-details">

            {/* Toggle Buttons */}
            <Row className="mb-3">
              <Col>
                <Button
                  variant={currentTab === 'list' ? 'primary' : 'outline-primary'}
                  onClick={() => setCurrentTab('list')}
                  className="me-2"
                >
                  List
                </Button>
                <Button
                  variant={currentTab === 'map' ? 'primary' : 'outline-primary'}
                  onClick={() => setCurrentTab('map')}
                >
                  Map
                </Button>
              </Col>
            </Row>

            <Row className="mt-2">
              <Col>
                {loadingDealer && <Skeleton height={50} />}

                {nearbyDealers.length > 0 && !loadingDealer && currentTab === 'list' && (
                  <Table striped bordered hover responsive>
                    <thead>
                      <tr>
                        <th>Serial no.</th>
                        <th>Dealer Name</th>
                        <th>Address</th>
                        <th>Contact</th>
                        <th>Distance</th>
                      </tr>
                    </thead>
                    <tbody>
                      {nearbyDealers.map((dealer, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{dealer.dealer_name}</td>
                          <td>{dealer.geo_address}</td>
                          <td>{dealer.contact_no}</td>
                          <td>{dealer.Distance}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}

                {nearbyDealers.length > 0 && !loadingDealer && currentTab === 'map' && (
                  <MapComp
                    className="absolute"
                    location={location}
                    dealerData={nearbyDealers}
                  />
                )}

                {nearbyDealers.length === 0 && !loadingDealer && (
                  <NoData title="No dealer found" />
                )}
              </Col>
            </Row>
          </div>
        </Card>
      )}

              

              {/* Delete my account */}
              {/* {deleteMyAccountTab &&
                <div className='userInfoBox'>
                <div className="dashboard-title">
                  <h4>Delete my account</h4>  
                </div>
                <div className='dashboard-details'>
                  <Row>
                      <Row>
                          <Col xs={4} className='mt-3'>
                            <PrimaryGradientButton buttonText="Delete My Account" onClick={handleDeleteMyAccount}
                            />
                          </Col>
                        </Row>
                  </Row>
                </div>
              </div>
            }  */}

              < Col xs={12}>
                <ModalComponent
                  page="cart"
                  isModalOpen={isModalOpen}
                  setIsModalOpen={setIsModalOpen}
                  outlinebuttonText="Delete My Account"
                  onClick={deleteMyAccountHandler}
                  modalTitle="Are you sure you want to delete your account?"
                  modalDescription="Deleting your account will permanently remove all your data and you will lose access to your account. Please note that this action cannot be undone."></ModalComponent>
              </Col>

              {/* Activity List */}

              {activityListTab &&
                <>
                  <div className='userInfoBox'>
                    <div className="dashboard-title">
                      <h4>Activity List</h4>
                    </div>
                    <div className='dashboard-details'>
                      <div className='notificationList'>
                        <ul>
                          <Row>
                             {noDataMsg && <Col><div className="error-message">No Data Found</div></Col> }
                            <Col>
                              {
                                activityData?.slice(0, visibleItemCount).map((item, index) => {
                                  const { activity, created_at } = item;

                                  let dateObject = new Date(created_at);
                                  let options = {
                                    day: 'numeric',
                                    month: 'long',
                                    year: 'numeric',
                                    timeZone: 'UTC'
                                  };
                                  return (
                                    <li key={item.id}>

                                      <div className='notificationDescription'><b>{activity}</b></div>
                                      <div className='notificationTime'><span className='clock-icon'><Clock /></span> {new Intl.DateTimeFormat('en-US', options).format(dateObject)}</div>

                                    </li>
                                  )

                                })
                              }

                            </Col>

                          </Row>
                        </ul>
                      </div>
                    </div>
                  </div>

                  {/* {visibleItemCount < activityData.length && (
                    <Container>
                      <Row className='justify-content-center mt-3'>
                        <Col xs={12} lg={3}>
                          <PrimaryGradientButton onClick={handleShowMore} buttonText='Show More' />

                        </Col>
                      </Row>
                    </Container>
                  )} */}
                </>
              }
            </Col>

          </Row>
        </Container>
      </section>

    </>
  )
}

export default Profile